import { t } from "../../../../../../../utils/i18n";
import React from "react";
import DisplayFile from "./DisplayFile";
interface Props {
  onClickEdit: (e: any, step: string) => void;
  data: any;
  cardType?: string;
}

const PersonalDetails: React.FC<Props> = ({ data, cardType, onClickEdit }) => (
  <div className="card-inner-container">
    <h6 className="card-sub-title">{t("cards.request_form.personal_details")}</h6>
    {data.lastName && (
      <div className="form-group row">
        <label className="col-12 col-md-3 form-label card-sub-title">
          {t("cards.request_form.last_name")}
        </label>
        <div className="col-12 col-md-9">
          <span>{data.lastName}</span>
        </div>
      </div>
    )}
    {data.firstName && (
      <div className="form-group row">
        <label className="col-12 col-md-3 form-label card-sub-title">
          {t("cards.request_form.first_name")}
        </label>
        <div className="col-12 col-md-9">
          <span>{data.firstName}</span>
        </div>
      </div>
    )}
    {data.middleName && (
      <div className="form-group row">
        <label className="col-12 col-md-3 form-label card-sub-title">
          {t("cards.request_form.middle_name")}
        </label>
        <div className="col-12 col-md-9">
          <span>{data.middleName}</span>
        </div>
      </div>
    )}
    <div className="form-group row">
      <label className="col-12 col-md-3 form-label card-sub-title">
        {t("cards.request_form.name_on_card")}
      </label>
      <div className="col-12 col-md-9">
        <span>{data.nameOnCard}</span>
      </div>
    </div>
    <div className="form-group row">
      <label className="col-12 col-md-3 form-label card-sub-title">
        {t("cards.request_form.occupation")}
      </label>
      <div className="col-12 col-md-9">
        <span>{data.occupation}</span>
      </div>
    </div>

    <div className="form-group row">
      <label className="col-12 col-md-3 form-label card-sub-title">
        {t("cards.request_form.phone_number")}
      </label>
      <div className="col-12 col-md-9">
        <span>{data.phoneNumber}</span>
      </div>
    </div>

    {data.annualSalary && (
      <div className="form-group row">
        <label className="col-12 col-md-3 form-label card-sub-title">
          {t("cards.request_form.annual_income")}
        </label>
        <div className="col-12 col-md-9">
          <span>{data.annualSalary}</span>
        </div>
      </div>
    )}
    {data.accountPurpose && (
      <div className="form-group row">
        <label className="col-12 col-md-3 form-label card-sub-title">
          {t("cards.request_form.account_purpose")}
        </label>
        <div className="col-12 col-md-9">
          <span>{data.accountPurpose}</span>
        </div>
      </div>
    )}
    {data.expectedMonthlyVolume && (
      <div className="form-group row">
        <label className="col-12 col-md-3 form-label card-sub-title">
          {t("cards.request_form.expected_monthly_spend")}
        </label>
        <div className="col-12 col-md-9">
          <span>{data.expectedMonthlyVolume}</span>
        </div>
      </div>
    )}
    <div className="form-group row">
      <label className="col-12 col-md-3 form-label card-sub-title">
        {t("cards.request_form.date_of_birth")}
      </label>
      <div className="col-12 col-md-9">
        <span>{data.dateOfBirth}</span>
      </div>
    </div>
    <div className="form-group row">
      <label className="col-12 col-md-3 form-label card-sub-title">
        {t("cards.request_form.passport_bio_page")}
      </label>
      <div className="col-12 col-md-9">
        <DisplayFile file={data.passportBioPage} />
      </div>
    </div>
    <div className="ml-auto">
      <a
        className="btn btn-purple"
        href="#"
        onClick={(e) => onClickEdit(e, "personal")}
      >
        {t("cards.request_form.edit")} <i className="fa fa-pen"></i>
      </a>
    </div>
  </div>
);

export default PersonalDetails;
